<!-- ADMIN LOGIN VIEW -->
<main *ngIf="loginRole === 'superadmin' || loginRole === 'csqadmin'">
  <div class="d-grid gap-3">
    <div
      class="d-flex justify-content-between align-items-center width-class w-100 flex-wrap gap-3"
    >
      <div
        class="d-flex gap-3 align-items-center"
        style="cursor: pointer"
        (click)="!pageloading && goBack()"
      >
        <img
          class="action-button"
          [class.skeleton-img]="pageloading"
          src="../../../../../assets/images/Buttons/arrow-left.svg"
          alt="left"
        />
        <div class="header-text m-0" [class.skeleton-text]="pageloading">
          Back to event list
        </div>
      </div>
    </div>

    <div class="event-card">
      <div class="w-100 d-grid gap-3 align-items-baseline">
        <div
          class="d-flex w-100 justify-content-between align-items-start flex-wrap gap-2"
        >
          <div class="d-flex gap-2 align-items-center flex-wrap">
            <span class="event-name" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : eventData?.eventName || "Event Name"
              }}
            </span>
          </div>

          <div class="d-grid gap-2 status-text" *ngIf="!pageloading">
            Status
            <div class="status-dropdown-container">
              <div
                class="status-display"
                [ngClass]="
                  getStatusClass(eventData?.eventAdminApprovalStatusName)
                "
              >
                {{
                  getStatusDisplayValue(
                    eventData?.eventAdminApprovalStatusName === "Pending"
                      ? "Awaiting Approval"
                      : eventData.eventAdminApprovalStatusName
                  )
                }}
              </div>
              <div class="status-skeleton" *ngIf="pageloading"></div>
            </div>
          </div>
        </div>

        <div class="details-layout">
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Type of work experience
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : eventData?.workExperienceTypeName || "-"
              }}
            </div>
            <div class="small-text" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : eventData?.workExperienceDesc || "-"
              }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Start date
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : (eventData?.eventStartDate | brisbaneDate: "dd-MM-yyyy") || "-"
              }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              End date
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : (eventData?.eventEndDate | brisbaneDate: "dd-MM-yyyy") || "-"
              }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              No. of days
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "Loading..." : eventData?.noOfDays || "-" }}
            </div>
          </div>
        </div>

        <div class="details-layout">
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Time
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "Loading..." : eventData?.eventTime || "-" }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Location
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "Loading..." : eventData?.location || "-" }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Company / Employer Name
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "Loading..." : eventData?.employerName || "-" }}
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <!-- <button class="evidence-button">
              <img
                class="download-icon"
                src="assets/images/download-media.svg"
                alt="download"
              />Download evidence
            </button> -->

            <button
              class="evidence-button"
              *ngIf="eventData?.imagePaths?.length > 0"
            >
              <div class="time">
                <div
                  *ngIf="getEventImage() && !isPdf()"
                  style="max-width: 200px"
                  class="d-flex gap-2 align-items-center px-2"
                  (click)="downloadFiles()"
                >
                  <img
                    class="download-icon"
                    style="filter: brightness(5); width: 20px; height: 20px"
                    src="assets/images/Buttons/view-button.svg"
                    alt="download"
                  />
                  View evidence
                </div>

                <div
                  *ngIf="getEventImage() && isPdf()"
                  style="max-width: 200px"
                  class="d-flex gap-2 align-items-center px-2"
                  (click)="downloadFiles()"
                >
                  <img
                    class="download-icon"
                    src="assets/images/download-icon.svg"
                    alt="download"
                  />
                  Download evidence
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Students Table Section -->
    <div class="table-details">
      <div class="settings-bg">
        <div
          class="d-flex justify-content-between settings-bg-button flex-wrap"
        >
          <div class="segment-buttons">
            <div [class.skeleton-text]="pageloading">Students</div>
          </div>
          <!-- <div class="add-buttons">
            <button
              (click)="openAddStudentDialog(eventData)"
              [disabled]="pageloading || studentTabelLoading"
            >
              <img
                src="assets/images/add-icon.svg"
                alt="plus"
                class="plus-icon"
                [class.skeleton-img]="pageloading"
              />
              <span [class.skeleton-text]="pageloading">Assign student</span>
            </button>
          </div> -->
          <div class="add-buttons" *ngIf="!eventData?.isDraft">
            <button
              class="export-csv-button"
              (click)="exportStudentsToCSV()"
              [disabled]="pageloading || !eventStudentList.length"
            >
              <img
                src="assets/images/download-icon.svg"
                alt="export"
                class="plus-icon"
                [class.skeleton-img]="pageloading"
              />
              <span [class.skeleton-text]="pageloading">Export</span>
            </button>
          </div>
        </div>

        <div class="table-page">
          <app-custom-reg-table
            [columns]="adminStudentColumn"
            [actionTemplate]="actionButtonsTemplate"
            [data]="eventStudentList"
            [loading]="false"
            [eventStatus]="eventData?.eventStatus"
            (toggleChange)="onToggleChange($event)"
            (downloadClick)="onDownloadConsent($event)"
            (noteUpdate)="onNoteUpdate($event)"
          >
          </app-custom-reg-table>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-overlay" *ngIf="showEventModal" (click)="closeEventModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <div>View evidence</div>
        <button class="close-btn" (click)="closeEventModal()">&times;</button>
      </div>

      <div class="modal-body">
        <img [src]="showEventModal" alt="Event Image" />
      </div>
    </div>
  </div>
</main>

<main *ngIf="loginRole === 'csquser'">
  <div class="d-grid gap-3">
    <div
      class="d-flex justify-content-between align-items-center width-class w-100 flex-wrap gap-3"
    >
      <div
        class="d-flex gap-3 align-items-center"
        style="cursor: pointer"
        (click)="!pageloading && goBack()"
      >
        <img
          class="action-button"
          [class.skeleton-img]="pageloading"
          src="../../../../../assets/images/Buttons/arrow-left.svg"
          alt="left"
        />
        <div class="header-text m-0" [class.skeleton-text]="pageloading">
          Back to event list
        </div>
      </div>
    </div>

    <div class="event-card">
      <div class="w-100 d-grid gap-3 align-items-baseline">
        <div
          class="d-flex w-100 justify-content-between align-items-start flex-wrap gap-2"
        >
          <div class="d-flex gap-2 align-items-center flex-wrap">
            <span class="event-name" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : eventData?.eventName || "Event Name"
              }}
            </span>
          </div>

          <div class="d-grid gap-2 status-text" *ngIf="!pageloading">
            Status
            <div class="status-dropdown-container">
              <div
                class="status-display"
                [ngClass]="
                  getStatusClass(eventData?.eventAdminApprovalStatusName)
                "
              >
                {{
                  getStatusDisplayValue(
                    eventData?.eventAdminApprovalStatusName === "Pending"
                      ? "Awaiting Approval"
                      : eventData.eventAdminApprovalStatusName
                  )
                }}
              </div>
              <div class="status-skeleton" *ngIf="pageloading"></div>
            </div>
          </div>
        </div>

        <div class="details-layout">
         <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Type of work experience
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : eventData?.workExperienceTypeName || "-"
              }}
            </div>
            <div class="small-text" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : eventData?.workExperienceDesc || "-"
              }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Start date
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : (eventData?.eventStartDate | brisbaneDate: "dd-MM-yyyy") || "-"
              }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              End date
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : (eventData?.eventEndDate | brisbaneDate: "dd-MM-yyyy") || "-"
              }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              No. of days
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "Loading..." : eventData?.noOfDays || "-" }}
            </div>
          </div>
        </div>

        <div class="details-layout">
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Time
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "Loading..." : eventData?.eventTime || "-" }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Location
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "Loading..." : eventData?.location || "-" }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Company / Employer Name
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "Loading..." : eventData?.employerName || "-" }}
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <!-- <button class="evidence-button">
              <img
                class="download-icon"
                src="assets/images/download-media.svg"
                alt="download"
              />Download evidence
            </button> -->

            <button
              class="evidence-button"
              *ngIf="eventData?.imagePaths?.length > 0"
            >
              <div class="time">
                <div
                  *ngIf="getEventImage() && !isPdf()"
                  style="max-width: 200px"
                  class="d-flex gap-2 align-items-center px-2"
                  (click)="downloadFiles()"
                >
                  <img
                    class="download-icon"
                    style="filter: brightness(5); width: 20px; height: 20px"
                    src="assets/images/Buttons/view-button.svg"
                    alt="download"
                  />
                  View evidence
                </div>

                <div
                  *ngIf="getEventImage() && isPdf()"
                  style="max-width: 200px"
                  class="d-flex gap-2 align-items-center px-2"
                  (click)="downloadFiles()"
                >
                  <img
                    class="download-icon"
                    src="assets/images/download-icon.svg"
                    alt="download"
                  />
                  Download evidence
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Students Table Section -->
    <div class="table-details">
      <div class="settings-bg">
        <div
          class="d-flex justify-content-between settings-bg-button flex-wrap"
        >
          <div class="segment-buttons">
            <div [class.skeleton-text]="pageloading">Students</div>
          </div>
          <div class="add-buttons">
            <button
              class="export-csv-button"
              (click)="exportStudentsToCSV()"
              [disabled]="pageloading || !eventStudentList.length"
            >
              <img
                src="assets/images/download-icon.svg"
                alt="export"
                class="plus-icon"
                [class.skeleton-img]="pageloading"
              />
              <span [class.skeleton-text]="pageloading">Export</span>
            </button>
            <button
              (click)="openAssignStudentsDialog()"
              [disabled]="pageloading || studentTabelLoading"
            >
              <img
                src="assets/images/add-icon.svg"
                alt="plus"
                class="plus-icon"
                [class.skeleton-img]="pageloading"
              />
              <span [class.skeleton-text]="pageloading">Assign student</span>
            </button>
          </div>
        </div>

        <div class="table-page">
          <app-custom-reg-table
            [columns]="adminStudentColumn"
            [actionTemplate]="actionButtonsTemplate"
            [data]="eventStudentList"
            [loading]="false"
            [eventStatus]="eventData?.eventStatus"
            (toggleChange)="onToggleChange($event)"
            (downloadClick)="onDownloadConsent($event)"
            (noteUpdate)="onNoteUpdate($event)"
          >
          </app-custom-reg-table>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-overlay" *ngIf="showEventModal" (click)="closeEventModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <div>View evidence</div>
        <button class="close-btn" (click)="closeEventModal()">&times;</button>
      </div>

      <div class="modal-body">
        <img [src]="showEventModal" alt="Event Image" />
      </div>
    </div>
  </div>
</main>

<main *ngIf="loginRole === 'teacher'">
  <div class="d-grid gap-3">
    <div
      class="d-flex justify-content-between align-items-center width-class w-100 flex-wrap gap-3"
    >
      <div
        class="d-flex gap-3 align-items-center"
        style="cursor: pointer"
        (click)="!pageloading && goBack()"
      >
        <img
          class="action-button"
          [class.skeleton-img]="pageloading"
          src="../../../../../assets/images/Buttons/arrow-left.svg"
          alt="left"
        />
        <div class="header-text m-0" [class.skeleton-text]="pageloading">
          Back to event list
        </div>
      </div>
    </div>

    <div class="event-card">
      <div class="w-100 d-grid gap-3 align-items-baseline">
        <div
          class="d-flex w-100 justify-content-between align-items-start flex-wrap gap-2"
        >
          <div class="d-flex gap-2 align-items-center flex-wrap">
            <span class="event-name" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : eventData?.eventName || "Event Name"
              }}
            </span>
          </div>

          <div class="d-flex gap-4">
            <div class="d-grid gap-2 status-text" *ngIf="!pageloading">
              Status
              <div class="status-dropdown-container">
                <div
                  class="status-display"
                  [ngClass]="getStatusClass(eventData?.eventAdminApprovalStatusName)"
                >
                 {{
                  getStatusDisplayValue(
                    eventData?.eventAdminApprovalStatusName === "Pending"
                      ? "Awaiting Approval"
                      : eventData.eventAdminApprovalStatusName
                  )
                }}
                </div>
                <div class="status-skeleton" *ngIf="pageloading"></div>

                <!-- Status Dropdown Menu -->
                <div
                  class="status-dropdown-menu"
                  [class.show]="showStatusDropdown"
                  (click)="$event.stopPropagation()"
                >
                  <ng-container
                    *ngIf="statusOptions.length > 0; else loadingStatus"
                  >
                    <div
                      *ngFor="let status of statusOptions"
                      class="status-option"
                      [class.active]="eventData?.eventStatus === status.value"
                      [class.loading]="approvalStatusLoading"
                      (click)="updateEventStatus(status)"
                    >
                      {{ status.label }}
                    </div>
                  </ng-container>
                  <ng-template #loadingStatus>
                    <div class="status-option loading">Loading...</div>
                  </ng-template>
                </div>

                <!-- Dropdown Backdrop -->
                <div
                  class="status-backdrop"
                  *ngIf="showStatusDropdown"
                  (click)="closeStatusDropdown()"
                ></div>
              </div>
            </div>

            <div
              class="blue-text"
              (click)="!pageloading && onEdit(eventData)"
              style="cursor: pointer"
            >
              <img
                class="action-button"
                [class.skeleton-img]="pageloading"
                src="assets/images/Buttons/edit-button.svg"
                alt="Edit"
              />
            </div>
          </div>
        </div>

        <div class="details-layout">
         <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Type of work experience
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : eventData?.workExperienceTypeName || "-"
              }}
            </div>
            <div class="small-text" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : eventData?.workExperienceDesc || "-"
              }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Start date
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : (eventData?.eventStartDate | brisbaneDate: "dd-MM-yyyy") || "-"
              }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              End date
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{
                pageloading
                  ? "Loading..."
                  : (eventData?.eventEndDate | brisbaneDate: "dd-MM-yyyy") || "-"
              }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              No. of days
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "Loading..." : eventData?.noOfDays || "-" }}
            </div>
          </div>
        </div>

        <div class="details-layout">
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Time
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "Loading..." : eventData?.eventTime || "-" }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Location
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "Loading..." : eventData?.location || "-" }}
            </div>
          </div>
          <div class="d-grid gap-2">
            <div class="primary-text" [class.skeleton-text]="pageloading">
              Company / Employer Name
            </div>
            <div class="secondary-text" [class.skeleton-text]="pageloading">
              {{ pageloading ? "Loading..." : eventData?.employerName || "-" }}
            </div>
          </div>

          <div class="d-flex justify-content-end">
            <button
              class="evidence-button"
              *ngIf="eventData?.imagePaths?.length > 0"
            >
              <div class="time">
                <div
                  *ngIf="getEventImage() && !isPdf()"
                  style="max-width: 200px"
                  class="d-flex gap-2 align-items-center px-2"
                  (click)="downloadFiles()"
                >
                  <img
                    class="download-icon"
                    style="filter: brightness(5); width: 20px; height: 20px"
                    src="assets/images/Buttons/view-button.svg"
                    alt="download"
                  />
                  View evidence
                </div>

                <div
                  *ngIf="getEventImage() && isPdf()"
                  style="max-width: 200px"
                  class="d-flex gap-2 align-items-center px-2"
                  (click)="downloadFiles()"
                >
                  <img
                    class="download-icon"
                    src="assets/images/download-icon.svg"
                    alt="download"
                  />
                  Download evidence
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="table-details">
      <div class="settings-bg">
        <div
          class="d-flex justify-content-between settings-bg-button flex-wrap"
        >
          <div class="segment-buttons">
            <div [class.skeleton-text]="pageloading">Students</div>
          </div>
          <div class="add-buttons">
            <button
              class="export-csv-button"
              (click)="exportStudentsToCSV()"
              [disabled]="pageloading || !eventStudentList.length"
            >
              <img
                src="assets/images/download-icon.svg"
                alt="export"
                class="plus-icon"
                [class.skeleton-img]="pageloading"
              />
              <span [class.skeleton-text]="pageloading">Export</span>
            </button>
            <button
              (click)="openAssignStudentsDialog()"
              [disabled]="pageloading || studentTabelLoading"
            >
              <img
                src="assets/images/add-icon.svg"
                alt="plus"
                class="plus-icon"
                [class.skeleton-img]="pageloading"
              />
              <span [class.skeleton-text]="pageloading">Assign student</span>
            </button>
          </div>
        </div>

        <div class="table-page">
          <app-custom-reg-table
            [columns]="adminStudentColumn"
            [actionTemplate]="actionButtonsTemplate"
            [data]="eventStudentList"
            [loading]="false"
            [eventStatus]="eventData?.eventStatus"
            (toggleChange)="onToggleChange($event)"
            (downloadClick)="onDownloadConsent($event)"
            (noteUpdate)="onNoteUpdate($event)"
          >
          </app-custom-reg-table>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-overlay" *ngIf="showEventModal" (click)="closeEventModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <div>View evidence</div>
        <button class="close-btn" (click)="closeEventModal()">&times;</button>
      </div>

      <div class="modal-body">
        <img [src]="showEventModal" alt="Event Image" />
      </div>
    </div>
  </div>
</main>

<main *ngIf="loginRole === 'student' && !isFetchingStudentData">
  <div class="d-grid gap-3">
    <div
      class="d-flex justify-content-between align-items-center width-class w-100 flex-wrap gap-3"
    >
      <div
        class="d-flex gap-3 align-items-center"
        style="cursor: pointer"
        (click)="!isLoading && goBack()"
      >
        <img
          class="action-button"
          [class.skeleton-img]="isLoading"
          src="../../../../../assets/images/Buttons/arrow-left.svg"
          alt="left"
        />
        <div class="header-text m-0" [class.skeleton-text]="isLoading">
          Back to event list
        </div>
      </div>
    </div>

    <div class="student-event-card">
      <div class="d-flex gap-4 w-100">
        <!-- <div class="student-event-image-container">
          <img
            class="student-event-image"
            [class.skeleton-img]="isLoading"
            [src]="
              isLoading
                ? 'assets/images/placeholder-image.svg'
                : eventData?.eventTypeImage ||
                  'assets/images/placeholder-image.svg'
            "
            [alt]="eventData?.eventTypeName"
          />
        </div> -->

        <div class="w-100 d-grid gap-3 align-items-baseline">
          <div
            class="d-flex w-100 justify-content-between align-items-center flex-wrap gap-2"
          >
            <div class="d-flex gap-2 align-items-center flex-wrap">
              <span class="event-name" [class.skeleton-text]="isLoading">
                {{
                  isLoading
                    ? "Loading..."
                    : eventData?.eventName || "Event Name"
                }}
              </span>
            </div>

            <div class="d-flex gap-4 align-items-center">
              <div class="d-grid gap-2 status-text" *ngIf="!isLoading">
                Status
                <div class="status-dropdown-container">
                  <div
                    class="status-display"
                    [ngClass]="getStatusClass(eventData?.status)"
                  >
                    {{ getStatusDisplayValue(eventData?.status) }}
                  </div>
                  <div class="status-skeleton" *ngIf="isLoading"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="details-layout-teacher">
            <div class="d-grid gap-2">
              <div class="primary-text" [class.skeleton-text]="isLoading">
                Event type
              </div>
              <div class="secondary-text" [class.skeleton-text]="isLoading">
                {{ isLoading ? "Loading..." : eventData?.eventType || "-" }}
              </div>
            </div>
            <div class="d-grid gap-2">
              <div class="primary-text" [class.skeleton-text]="isLoading">
                Start date
              </div>
              <div class="secondary-text" [class.skeleton-text]="isLoading">
                {{
                  isLoading
                    ? "Loading..."
                    : (eventData?.eventStartDate | brisbaneDate: "dd-MM-yyyy") || "-"
                }}
              </div>
            </div>
            <div class="d-grid gap-2">
              <div class="primary-text" [class.skeleton-text]="isLoading">
                End date
              </div>
              <div class="secondary-text" [class.skeleton-text]="isLoading">
                {{
                  isLoading
                    ? "Loading..."
                    : (eventData?.eventEndDate | brisbaneDate: "dd-MM-yyyy") || "-"
                }}
              </div>
            </div>
          </div>

          <div class="details-layout-teacher">
            <div class="d-grid gap-2">
              <div class="primary-text" [class.skeleton-text]="isLoading">
                Time
              </div>
              <div class="secondary-text" [class.skeleton-text]="isLoading">
                {{ isLoading ? "Loading..." : eventData?.eventTime || "-" }}
              </div>
            </div>
            <div class="d-grid gap-2">
              <div class="primary-text" [class.skeleton-text]="isLoading">
                Location
              </div>
              <div class="secondary-text" [class.skeleton-text]="isLoading">
                {{ isLoading ? "Loading..." : eventData?.location || "-" }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="d-flex w-100 align-items-center">
        <button class="int-button" [disabled]="isRegistered || isLoading">
          <span [class.skeleton-text]="isLoading">
            {{
              isLoading
                ? "Loading..."
                : isRegistered
                  ? "Already Registered"
                  : "Are you Interested?"
            }}
          </span>
        </button>
      </div> -->
    </div>
  </div>
</main>

<ng-template #actionButtons let-row>
  <div style="display: flex; gap: 0.8rem; justify-content: center; align-items: center;">
    <ng-container *ngIf="row.status === 'Interested'">
      <button
        class="btn-approve-interested"
        (click)="approveInterestedStudent(row)"
        title="Approve">
        Approve
      </button>
      <button
        class="btn-decline-interested"
        (click)="declineInterestedStudent(row)"
        title="Decline">
        Decline
      </button>
    </ng-container>
    <img
      class="action-button"
      (click)="onDelete(row)"
      src="assets/images/Buttons/delete-button.svg"
      alt="Delete"
    />
  </div>
</ng-template>
